import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { getDocumentsVersions } from '../requests';

export const useGetDocumentsVersions = (documentId?: number) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.documentsVersions, { documentId: documentId! }],
    queryFn: () => getDocumentsVersions({ documentId: documentId! }),
    enabled: !!documentId,
  });
